import { Component, Inject, OnInit } from '@angular/core';
import { ContactService } from '../services/contact.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditContactComponent } from '../edit-contact/edit-contact.component';

@Component({
  selector: 'app-delete-contact',
  templateUrl: './delete-contact.component.html',
  styleUrls: ['./delete-contact.component.scss']
})
export class DeleteContactComponent implements OnInit {

  contactID: number;
  businessID: number;
  isLoading = false;
  constructor(private _matDialogRef: MatDialogRef<EditContactComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _contactService: ContactService) {
    this.contactID = data.contactID;
    this.businessID = data.businessID;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._contactService.deleteBusinessContact(this.businessID, this.contactID);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }

}
